const defaultConfig = {
  CURRENT_ENV: 'LOCAL',
  ENVIRONMENTS: {
    LOCAL: { BASEURL: "http://localhost:5005//api", URL: "http://localhost:5005//" },
    DEMO: { BASEURL: "http://172.16.1.8:8181/api", URL: "http://172.16.1.8:8181/" },
    DEMO_ELDER: { BASEURL: "http://172.16.1.8:9010/api", URL: "http://172.16.1.8:9010/" },
    INTERNO: { BASEURL: "http://172.16.1.8:8184/api", URL: "http://172.16.1.8:8184/" },
    EXTERNO: [
      { name: "Bitel", BASEURL: "https://181.176.215.138:8190/api", URL: "https://181.176.215.138:8190/" },
      { name: "Claro", BASEURL: "https://190.116.178.179:8189/api", URL: "https://190.116.178.179:8189/" }
    ]
  }
};

const getConfig = () => {
  if (typeof window !== "undefined" && window.APP_CONFIG) {
    return window.APP_CONFIG;
  }
  return defaultConfig;
};

const getExternalAPIs = () => {
  const cfg = getConfig();
  const envs = cfg.ENVIRONMENTS || defaultConfig.ENVIRONMENTS;
  const external = envs.EXTERNO || defaultConfig.ENVIRONMENTS.EXTERNO;
  return Array.isArray(external) ? external : [external];
};

export const getCurrentExternalIndex = () => {
  const apis = getExternalAPIs();
  let idx = parseInt(localStorage.getItem('currentExternalIndex') || '0', 10);
  if (isNaN(idx) || idx < 0 || idx >= apis.length) {
    idx = 0;
  }
  return idx;
};

export const switchExternalNetwork = (failedBaseURL) => {
  const apis = getExternalAPIs();
  let idx = getCurrentExternalIndex();
  // Solo cambia si la URL actual coincide con la que falló o si se llama sin parámetro
  if (!failedBaseURL || (apis[idx] && apis[idx].BASEURL === failedBaseURL)) {
    idx = (idx + 1) % apis.length;
    localStorage.setItem('currentExternalIndex', idx);
  }
};

const getActiveEnvConfig = () => {
  const cfg = getConfig();
  const currentEnv = cfg.CURRENT_ENV || 'LOCAL';
  const envs = cfg.ENVIRONMENTS || defaultConfig.ENVIRONMENTS;

  if (currentEnv === 'EXTERNO') {
    const apis = getExternalAPIs();
    const idx = getCurrentExternalIndex();
    return apis[idx] || apis[0];
  }

  return envs[currentEnv] || envs.LOCAL || defaultConfig.ENVIRONMENTS.LOCAL;
};

export default {
  get CURRENT_ENV() {
    const cfg = getConfig();
    return cfg.CURRENT_ENV || 'LOCAL';
  },
  get IS_EXTERNAL() {
    return this.CURRENT_ENV === 'EXTERNO';
  },
  get BASEURL() {
    return getActiveEnvConfig().BASEURL;
  },
  get URL() {
    return getActiveEnvConfig().URL;
  },
  get externalAPIs() {
    return getExternalAPIs();
  },
  get currentExternalIndex() {
    return getCurrentExternalIndex();
  },

  ID_AREA_MANTENIMIENTO: 24, //32 sistemasdss
  _cKey: "@cl4V3*/",
  _cVec: "@cl4V3*/",
  FormatDateDB: "YYYY-MM-DD",
  FormatDateTimeDB: "YYYY-MM-DD HH:mm",
  FormatDateTimeShortDB: "YYYY-MM-DD HH:mm:ss",
  FormaTimeDB: "YYYY-MM-DD HH:mm",
  FormatDateView: "DD/MM/YYYY",
  FormatDateTimeView: "DD/MM/YYYY HH:mm",
  FormatDateTimeShortView: "DD/MM/YYYY HH:mm:ss",
  FormatDateTimeShort12HView: "DD/MM/YYYY hh:mm:ss A",
  FormatTimeDB: " HH:mm",
  FormatTimeView: " HH:mm",
  FormatTimeShortView: "HH:mm:ss",
  FormatTimeMask: " ##:##",
  FormatDateMask: "##/##/####",
  FormatDateTimeMask: "##/##/#### ##:##",
  TypeMeal: 1065,
  TypeLevel: {
    Administrador: 1,
    Asistente: 2,
    Jefatura: 3,
    Gerencia: 4,
    PorPlanilla: 5,
    PorArea: 6,
  },
  SreStatus: {
    EnCreacion: 1,
    EnAprobacion: 2,
    PendienteRRHH: 3,
    Observado: 4,
    Aprobado: 5,
    Atendido: 6,
    Anulado: 7,
  },
  SraStatus: {
    NoAsignado: 1,
    Pendiente: 2,
    Rechazado: 3,
    Aprobado: 4,
  },
  TypeStaffRequirement: {
    Simple: 1,
    Campaña: 2,
    Referencia: 3,
  },
  PosStatus: {
    Registrado: 1,
    Seleccionado: 2,
    Contratado: 3,
  },
  TypeDocument: {
    RequerimientoPersonal: 1,
    FichaMedica: 2,
  },
  TypeQualification: {
    Apto: 1,
    AptoCR: 2,
    NoApto: 3,
    Observado: 4,
    Pendiente: 5,
  },
  TypeTurn: {
    Diurno: 1,
    Nocturno: 2,
    Indistinto: 3,
  },
  MevStatus: {
    EnCreacion: 1,
    EnAprobacion: 2,
    Aprobado: 3,
    Anulado: 4,
    Observada: 5,
    Pendiente: 9,
  },
  CrdStatus: {
    Registrado: 1,
    Asignado: 2,
    Liberado: 3,
    Anulado: 4,
  },
  TypeCard: {
    Comedor: 4,
    Visita: 5,
    Trabajador: 6,
    Especial: 7,
  },
  SecStatus: {
    Activo: 1,
    Baja: 2,
  },
  TypePerson: {
    PersonaNatural: 1, // Todas las personas naturales
    PersonaJuridica: 2,
    Trabajadores: 3,
  },
  TypePersonDocument: {
    DNI: 1, // Todas las personas naturales
    CE: 2,
    RUC: 3,
    PAS: 4,
    PNAC: 5,
  },
  TypeRelation: { Child: 1, Spouse: 2 },
  DocumentNumberGeneric: {
    Company: "20329725431",
  },

  Months: [
    { value: 1, text: "Enero" },
    { value: 2, text: "Febrero" },
    { value: 3, text: "Marzo" },
    { value: 4, text: "Abril" },
    { value: 5, text: "Mayo" },
    { value: 6, text: "Junio" },
    { value: 7, text: "Julio" },
    { value: 8, text: "Agosto" },
    { value: 9, text: "Septiembre" },
    { value: 10, text: "Octubre" },
    { value: 11, text: "Noviembre" },
    { value: 12, text: "Diciembre" },
  ],
  TypeFile: {
    EXCEL: {
      ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Extension: "xlsx",
    },
    PDF: { ContentType: "application/pdf", Extension: "pdf" },
    ZIP: { ContentType: "application/pdf", Extension: "zip" },
  },
  Days: [
    { value: 1, text: "Lunes", abrv: "Lun" },
    { value: 2, text: "Martes", abrv: "Mar" },
    { value: 3, text: "Miércoles", abrv: "Mié" },
    { value: 4, text: "Jueves", abrv: "Jue" },
    { value: 5, text: "Viernes", abrv: "Vie" },
    { value: 6, text: "Sábado", abrv: "Sáb" },
    { value: 7, text: "Domingo", abrv: "Dom" },
  ],
};
